import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import LoadingSpinner from '../components/LoadingSpinner';

import {
  GetAllUsers,
  fetchUserRoles,
  registerUser,
  UpdateUsers,
  fetchCompany,
  fetchActiveDepartments,
} from "../services/apiService";
import Select from "react-select";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../services/msalConfig";

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [departmentsMaster, setMasterDepartments] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDept, setSelectedDept] = useState("");
  const [selectedCompany, setselectedCompany] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [companies, SetCompany] = useState([]);
  const [adUsers, setAdUsers] = useState([]);
  const { instance } = useMsal();

  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [formData, setFormData] = useState({
    username: "",
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    is_active: true,
    userCompanies: [],
  });

const [temp, setTemp] = useState({
  companyCode: "",
  department_id: "",
  role: "",
  username: "",
  is_default: false, // ✅ ADD THIS
});
  const userOptions = adUsers.map((u) => ({
    value: u.userPrincipalName,
    label: `${u.displayName} (${u.userPrincipalName})`,
    givenName: u.givenName || "",
    surname: u.surname || "",
    displayName: u.displayName || "",
  }));

  useEffect(() => {
    const initPage = async () => {
      try {
        await Promise.all([loadData(), loadCompany(), loadDepartments()]);
        const accounts = instance.getAllAccounts();
        if (accounts.length > 0) {
          instance.setActiveAccount(accounts[0]);
          await instance.acquireTokenSilent({ ...loginRequest, account: accounts[0] });
          await loadAzureADUsers();
        } else {
          await instance.loginPopup(loginRequest);
          await loadAzureADUsers();
        }
      } catch (e) {
        try {
          await instance.loginPopup(loginRequest);
          await loadAzureADUsers();
        } catch (err) {
          console.error("Failed to load AD users", err);
        }
      } finally {
        setIsPageLoading(false);
      }
    };
    initPage();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedDept]);

  useEffect(() => {
    const fetchDepartmentsByCompany = async () => {
      try {
        const allDepartments = await fetchActiveDepartments();
        const filteredDepartments = allDepartments.filter(
          (dept) => dept.company === formData.companyCode
        );
        setDepartments(filteredDepartments);
      } catch (error) {
        console.error("Error loading departments:", error);
        toast.error("Failed to load departments.");
      }
    };
    fetchDepartmentsByCompany();
  }, [formData.companyCode]);

  const loadDepartments = async () => {
    try {
      const data = await fetchActiveDepartments();
      setMasterDepartments(data);
    } catch (err) {
      console.error("Failed to fetch departments", err);
      toast.error("Failed to load departments.");
    }
  };

  const loadAzureADUsers = async () => {
    try {
      const accounts = instance.getAllAccounts();
      if (accounts.length === 0) {
        toast.error("No signed-in account found. Please login.");
        return;
      }

      instance.setActiveAccount(accounts[0]);
      const account = instance.getActiveAccount();
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account,
      });

      let users = [];
      let url = "https://graph.microsoft.com/v1.0/users?$top=999";

      while (url) {
        const res = await fetch(url, {
          headers: {
            Authorization: `Bearer ${response.accessToken}`,
          },
        });
        const data = await res.json();
        users = [...users, ...data.value];
        url = data["@odata.nextLink"] || null;
      }

      setAdUsers(users);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load Azure AD users");
    }
  };

  const loadData = async () => {
    try {
      const [userList, roleList] = await Promise.all([
        GetAllUsers(),
        fetchUserRoles(),
      ]);
      setUsers(userList);
      setRoles(roleList);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load data.");
    }
  };

  const loadCompany = async () => {
    try {
      const data = await fetchCompany();
      SetCompany(data);
    } catch (err) {
      console.error("Failed to fetch companies", err);
      toast.error("Failed to load companies.");
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
const handleAddNew = () => {
  setFormData({
    username: "",
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    is_active: true,
    userCompanies: [],
  });
  setTemp({ companyCode: "", department_id: "", role: "", username: "", is_default: false }); // ✅ reset temp too
  setEditingUser(null);
  setShowModal(true);
};

 const handleEdit = (user) => {
  setFormData({ ...user });
  setTemp({ companyCode: "", department_id: "", role: "", username: "", is_default: false }); // ✅ reset temp too
  setEditingUser(user);
  setShowModal(true);
};

  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const handleSubmit = async () => {
  const { email, password, first_name, last_name, userCompanies } = formData;

  if (!email || !first_name || !last_name) {
    toast.error("Email, First Name, and Last Name are required.");
    return;
  }

  if (!isValidEmail(email)) {
    toast.error("Please enter a valid email address.");
    return;
  }

  if (!editingUser && !password) {
    toast.error("Password is required for new users.");
    return;
  }

  if (!editingUser && users.some((u) => u.email === email)) {
    toast.error("Email already exists.");
    return;
  }

  // ✅ Validate at least one company is assigned
  if (!userCompanies || userCompanies.length === 0) {
    toast.error("Please assign at least one Company, Department, and Role.");
    return;
  }

  // ✅ Validate exactly one default is set
  const defaultCount = userCompanies.filter((uc) => uc.is_default).length;
  if (defaultCount === 0) {
    toast.error("Please set one company access as default.");
    return;
  }
  if (defaultCount > 1) {
    toast.error("Only one company access can be set as default.");
    return;
  }

  try {
    const userToSave = {
      ...formData,
      username: email,
      userCompanies,
      password: editingUser ? undefined : password,
    };

    const savedRequest = editingUser
      ? await UpdateUsers(userToSave)
      : await registerUser(userToSave);

    if ([400, 405].includes(savedRequest.status)) {
      toast.error("User already exists or failed to update.");
      return;
    } else if (savedRequest.status === 500) {
      toast.error("Server error. Try again later.");
      return;
    }

    toast.success(
      editingUser
        ? "User updated successfully!"
        : "New user saved successfully!"
    );

    setShowModal(false);
    loadData();
  } catch (err) {
    console.error(err);
    toast.error("Failed to save user.");
  }
};

const addUserCompany = () => {
  if (!temp.companyCode || !temp.department_id || !temp.role) return;

  const exists = formData.userCompanies.some(
    (uc) =>
      uc.companyCode === temp.companyCode &&
      uc.department_id === +temp.department_id &&
      uc.role === temp.role
  );
  if (exists) return;

  // ✅ If this entry is marked default, unset all others
  const updatedCompanies = temp.is_default
    ? formData.userCompanies.map((uc) => ({ ...uc, is_default: false }))
    : [...formData.userCompanies];

  // ✅ If no existing default, force this one to be default
  const hasDefault = updatedCompanies.some((uc) => uc.is_default);
  const newEntry = {
    ...temp,
    username: formData.email,
    is_default: temp.is_default || !hasDefault, // auto-default if first entry
  };

  setFormData((prev) => ({
    ...prev,
    userCompanies: [...updatedCompanies, newEntry],
  }));
  setTemp({ companyCode: "", department_id: "", role: "", username: "", is_default: false });
};

const removeUserCompany = (index) => {
  setFormData((prev) => {
    const updated = prev.userCompanies.filter((_, i) => i !== index);
    // If removed entry was default and others exist, make first one default
    const wasDefault = prev.userCompanies[index]?.is_default;
    if (wasDefault && updated.length > 0) {
      updated[0] = { ...updated[0], is_default: true };
    }
    return { ...prev, userCompanies: updated };
  });
};

  const handleTempChange = (e) => {
    const { name, value } = e.target;
    setTemp((prev) => ({ ...prev, [name]: value }));
  };

  const filteredUsers = users.filter((user) => {
    const term = searchTerm.toLowerCase();
    const userRoles = (user.userCompanies || []).map((uc) => uc.role || "");
    const matchesSearch =
      user.username.toLowerCase().includes(term) ||
      user.email.toLowerCase().includes(term) ||
      `${user.first_name} ${user.last_name}`.toLowerCase().includes(term) ||
      userRoles.some((r) => r.toLowerCase().includes(term));
    const matchesCompany =
      !selectedCompany || (user.userCompanies || []).some((uc) => String(uc.companyCode) === selectedCompany);
    const matchesDepartment =
      !selectedDept || (user.userCompanies || []).some((uc) => String(uc.department_id) === selectedDept);
    const matchesRole =
      !selectedRole || userRoles.some((r) => r === selectedRole);
    return matchesSearch && matchesDepartment && matchesCompany && matchesRole;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

  if (isPageLoading) return <LoadingSpinner label="Loading Users" />;

  return (
    <div className="flex flex-col  2xl:px-[10%] pt-8 bg-white xl:pt-24 md:pt-8 md:rounded-t-[40px] xl:rounded-t-[48px] mx-4 h-[70vh] sm:h-[72vh] md:h-[74.5vh] lg:h-[74.5vh] xl:px-[calc(8%-1rem)] 3xl:px-[calc(8%-1rem)] 4xl:[padding-inline:calc(9.5%-1rem)] md:px-[calc(5%-1rem)]">
      <div className='bg-white rounded-2xl p-6   filter drop-shadow-[0_5px_30px_rgba(10,60,96,0.10)]  h-[70vh] sm:h-[65vh] md:h-[68vh] lg:h-[63vh] xl:h-[90vh] overflow-y-auto relative xl:-top-[160px]'>
        <div className="flex flex-col sm:flex-col md:flex-row md:items-center md:gap-4 xl:gap-6 w-full">
          <h3 className="text-xl sm:text-2xl text-primary-800 font-semibold mb-4 md:mb-0">
            User Details
          </h3>

          <div className="flex flex-wrap sm:gap-4 md:flex-nowrap md:gap-4 ml-auto w-full md:w-auto">
            <select
              className="w-full sm:w-auto md:w-auto bg-white text-gray-600 font-semibold rounded-xl border border-gray-500 focus:outline-none focus:ring-1 focus:ring-primary-600 px-3 py-2"
              value={selectedCompany}
              onChange={(e) => setselectedCompany(e.target.value)}
            >
              <option value="">All Company</option>
              {companies.map((d) => (
                <option key={d.companyCode} value={d.companyCode}>
                  {d.companyName}
                </option>
              ))}
            </select>

            <select
              className="w-full sm:w-auto md:w-auto bg-white text-gray-600 font-semibold rounded-xl border border-gray-500 focus:outline-none focus:ring-1 focus:ring-primary-600 px-3 py-2"
              value={selectedDept}
              onChange={(e) => setSelectedDept(e.target.value)}
            >
              <option value="">All Departments</option>
              {departmentsMaster
                .filter((d) => String(d.company) === String(selectedCompany))
                .map((d) => (
                  <option key={d.department_id} value={d.department_id}>
                    {d.department_name}
                  </option>
                ))}
            </select>

            <select
              className="w-full sm:w-auto md:w-auto bg-white text-gray-600 font-semibold rounded-xl border border-gray-500 focus:outline-none focus:ring-1 focus:ring-primary-600 px-3 py-2"
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
            >
              <option value="">All Roles</option>
              {roles.map((r) => (
                <option key={r.userRoles_id} value={r.role}>
                  {r.role}
                </option>
              ))}
            </select>

            <div className="w-full sm:w-auto md:flex-1 flex items-center">
              <input
                type="text"
                className="w-full sm:w-auto md:w-auto bg-white text-gray-600 font-semibold rounded-xl border border-gray-500 focus:outline-none focus:ring-1 focus:ring-primary-600 px-3 py-2"
                placeholder="Search Demand plan by Department, Company or Role..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <select
              className="w-full sm:w-auto md:w-auto bg-white text-gray-600 font-semibold rounded-xl border border-gray-500 focus:outline-none focus:ring-1 focus:ring-primary-600 px-3 py-2"
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(Number(e.target.value))}
            >
              {[5, 10, 20, 50].map((n) => (
                <option key={n} value={n}>
                  {n} / page
                </option>
              ))}
            </select>

            <button
              onClick={handleAddNew}
              className="w-full sm:w-auto md:w-auto bg-primary-800 text-white px-6 py-2 rounded-xl text-base xl:text-lg"
            >
              + Add New User
            </button>
          </div>
        </div>

        <div className="bg-[#F6F5F175] p-4 rounded-lg mb-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          </div>
        </div>

        <div className="overflow-x-auto pt-6">
          <table className="min-w-full table-auto border-collapse">
            <thead className="bg-[#f5f3ef] text-primary-600 py-2 px-2 border-r border-primary-500/20 bg-primary-800/10 text-primary-800 text-left ">
              <tr>
                <th className="py-3 px-4 border-r border-primary-500/20">Username</th>
                <th className="py-3 px-4 border-r border-primary-500/20">Name</th>
                <th className="py-3 px-4 border-r border-primary-500/20">Email</th>
                <th className="py-3 px-4 border-r border-primary-500/20">Company Access</th>
                <th className="py-3 px-4 border-r border-primary-500/20">Status</th>
                <th className="py-3 px-4 border-r border-primary-500/20">Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers.map((user, index) => (
                <tr
                  key={user.user_id}
                  className={`${
                    index % 2 === 0 ? "bg-white" : "bg-primary-800/10"
                  } hover:bg-gray-50 transition border-b text-sm text-primary-600`}
                >
                  <td className="px-4 py-2 border-r text-[#232323]">{user.username}</td>
                  <td className="px-4 py-2 border-r text-[#232323] hidden sm:table-cell">
                    {user.first_name} {user.last_name}
                  </td>
                  <td className="px-4 py-2 border-r text-[#232323] hidden md:table-cell">
                    {user.email}
                  </td>
                  <td className="px-4 py-2 border-r text-[#232323]">
                    <div className="flex flex-wrap gap-1">
                      {(user.userCompanies || []).map((uc, i) => {
                        const name = companies.find(
                          (c) => String(c.companyCode) === String(uc.companyCode)
                        )?.companyName || uc.companyCode;
                        return (
                          <span
                            key={i}
                            className="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full"
                            style={{
                              backgroundColor: uc.is_default ? "rgba(18,76,114,0.12)" : "rgba(0,0,0,0.05)",
                              color: uc.is_default ? "rgb(18,76,114)" : "#555",
                            }}
                            title={uc.role ? `${name} — ${uc.role}` : name}
                          >
                            {uc.is_default && <span>★</span>}
                            {name}{uc.role ? ` · ${uc.role}` : ""}
                          </span>
                        );
                      })}
                      {(!user.userCompanies || user.userCompanies.length === 0) && (
                        <span className="text-gray-400 text-xs">—</span>
                      )}
                    </div>
                  </td>
                  <td className="px-4 py-2 border-r text-[#232323] text-center hidden lg:table-cell">
                    {user.is_active ? "Active" : "Inactive"}
                  </td>
                  <td className="px-4 py-2 border text-center">
                    <button
                      onClick={() => handleEdit(user)}
                      className="bg-primary-800/30 p-2 rounded-xl flex items-center cursor-pointer hover:bg-primary-800 w-full text-center"
                    >
                      <span className='text-primary-800 hover:text-[#fff] w-full'>Edit</span>
                    </button>
                  </td>
                </tr>
              ))}
              {users.length === 0 && (
                <tr>
                  <td colSpan={7} className="text-center text-gray-500 py-4">
                    No users found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {filteredUsers.length > itemsPerPage && (
            <div className="flex justify-center items-center mt-4 space-x-2 mt-6 mb-6">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                className="px-3 py-1 bg-[#f5f3ef] text-primary-600 rounded disabled:opacity-50"
                disabled={currentPage === 1}
              >
                Previous
              </button>
              {Array.from({ length: Math.ceil(filteredUsers.length / itemsPerPage) }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentPage(index + 1)}
                  className={`px-3 py-1 rounded ${
                    currentPage === index + 1 ? "bg-primary-600 text-white" : "bg-white text-primary-600"
                  } border`}
                >
                  {index + 1}
                </button>
              ))}
              <button
                onClick={() => setCurrentPage((prev) =>
                  Math.min(prev + 1, Math.ceil(filteredUsers.length / itemsPerPage))
                )}
                className="px-3 py-1 bg-[#f5f3ef] text-primary-600 rounded disabled:opacity-50"
                disabled={currentPage === Math.ceil(filteredUsers.length / itemsPerPage)}
              >
                Next
              </button>
            </div>
          )}
        </div>
        <footer className="w-full bg-[#f5f3ef] text-primary-600 py-4 px-6 mt-auto shadow-inner mt-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm">
            <span className="mb-2 md:mb-0">&copy; {new Date().getFullYear()} Digital & Transformation Department. All rights reserved.</span>
            <div className="flex space-x-4">
              <a className="hover:underline">Privacy Policy</a>
              <a className="hover:underline">Terms of Service</a>
            </div>
          </div>
        </footer>
      </div>

      {/* Modal - ONLY THIS SECTION IS CHANGED */}
      {showModal && (
        <div className="fixed inset-0 backdrop-blur-sm flex justify-center items-center z-50 p-4" style={{ backgroundColor: 'rgba(18, 76, 114, 0.2)' }}>
          <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl lg:max-w-3xl" style={{ borderColor: 'rgba(18, 76, 114, 0.1)', borderWidth: '1px' }}>
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b rounded-t-2xl" style={{ 
              borderColor: 'rgba(18, 76, 114, 0.1)',
              background: 'linear-gradient(to right, rgba(18, 76, 114, 0.05), transparent)'
            }}>
              <h2 className="text-xl font-semibold" style={{ color: 'rgb(18, 76, 114)' }}>
                {editingUser ? 'Edit User' : 'Add New User'}
              </h2>
              <button 
                onClick={() => setShowModal(false)} 
                className="transition-all rounded-full p-1.5"
                style={{ color: 'rgba(18, 76, 114, 0.6)' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgb(18, 76, 114)';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = 'rgba(18, 76, 114, 0.6)';
                }}
                aria-label="Close"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6 max-h-[70vh] overflow-y-auto">
              <div className="space-y-6">
                {/* Basic User Info */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  {/* User Selection */}
                  <div className="space-y-2">
                    <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                      Search User
                    </label>
                    <Select
                      options={userOptions}
                      value={userOptions.find((opt) => opt.value === formData.email) || null}
                      className="w-full"
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          borderColor: 'rgba(18, 76, 114, 0.3)',
                          borderRadius: '0.5rem',
                          padding: '2px',
                          boxShadow: state.isFocused ? '0 0 0 2px rgba(18, 76, 114, 0.2)' : 'none',
                          '&:hover': {
                            borderColor: 'rgb(18, 76, 114)'
                          }
                        }),
                        placeholder: (base) => ({
                          ...base,
                          color: '#6B7280'
                        })
                      }}
                      onChange={(selected) => {
                        if (selected) {
                          setFormData((prev) => ({
                            ...prev,
                            email: selected.value,
                            username: selected.value.split("@")[0],
                            full_name: selected.displayName,
                            first_name: selected.givenName,
                            last_name: selected.surname,
                          }));
                        } else {
                          setFormData((prev) => ({
                            ...prev,
                            email: "",
                            username: "",
                            full_name: "",
                            first_name: "",
                            last_name: "",
                          }));
                        }
                      }}
                      placeholder="Search and select user"
                      isClearable
                    />
                  </div>

                  {/* First Name */}
                  <div className="space-y-2">
                    <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                      First Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChange}
                      className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                      style={{ 
                        borderColor: 'rgba(18, 76, 114, 0.3)',
                        backgroundColor: 'white'
                      }}
                      onFocus={(e) => {
                        e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                        e.target.style.borderColor = 'rgb(18, 76, 114)';
                      }}
                      onBlur={(e) => {
                        e.target.style.boxShadow = 'none';
                        e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                      }}
                      placeholder="Enter first name"
                    />
                  </div>

                  {/* Last Name */}
                  <div className="space-y-2">
                    <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                      Last Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleChange}
                      className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                      style={{ 
                        borderColor: 'rgba(18, 76, 114, 0.3)',
                        backgroundColor: 'white'
                      }}
                      onFocus={(e) => {
                        e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                        e.target.style.borderColor = 'rgb(18, 76, 114)';
                      }}
                      onBlur={(e) => {
                        e.target.style.boxShadow = 'none';
                        e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                      }}
                      placeholder="Enter last name"
                    />
                  </div>

                  {/* Password (for new users) */}
                  {!editingUser && (
                    <div className="space-y-2">
                      <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                        Password <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                        style={{ 
                          borderColor: 'rgba(18, 76, 114, 0.3)',
                          backgroundColor: 'white'
                        }}
                        onFocus={(e) => {
                          e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                          e.target.style.borderColor = 'rgb(18, 76, 114)';
                        }}
                        onBlur={(e) => {
                          e.target.style.boxShadow = 'none';
                          e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                        }}
                        placeholder="Enter password"
                      />
                    </div>
                  )}
                </div>

                {/* Company Access Section */}
                <div className="space-y-4">
                  <div className="border rounded-lg p-4" style={{ 
                    borderColor: 'rgba(18, 76, 114, 0.2)',
                    backgroundColor: 'rgba(18, 76, 114, 0.03)'
                  }}>
                    <h4 className="text-sm font-medium mb-3" style={{ color: 'rgb(18, 76, 114)' }}>
                      Add Company Access
                    </h4>
                    
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                      {/* Company */}
                      <div className="space-y-2">
                        <label className="block text-xs font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                          Company
                        </label>
                        <select
                          name="companyCode"
                          value={temp.companyCode}
                          onChange={handleTempChange}
                          className="w-full px-3 py-2 border rounded-lg outline-none transition text-gray-700 text-sm"
                          style={{ 
                            borderColor: 'rgba(18, 76, 114, 0.3)',
                            backgroundColor: 'white'
                          }}
                        >
                          <option value="">Select Company</option>
                          {companies.map((c) => (
                            <option key={c.companyCode} value={c.companyCode}>{c.companyName}</option>
                          ))}
                        </select>
                      </div>

                      {/* Department */}
                      <div className="space-y-2">
                        <label className="block text-xs font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                          Department
                        </label>
                        <select
                          name="department_id"
                          value={temp.department_id}
                          onChange={handleTempChange}
                          className="w-full px-3 py-2 border rounded-lg outline-none transition text-gray-700 text-sm"
                          style={{ 
                            borderColor: 'rgba(18, 76, 114, 0.3)',
                            backgroundColor: 'white'
                          }}
                        >
                          <option value="">Select Department</option>
                          {departmentsMaster
                            .filter((d) => d.company === temp.companyCode)
                            .map((d) => (
                              <option key={d.department_id} value={d.department_id}>{d.department_name}</option>
                            ))}
                        </select>
                      </div>

                      {/* Role */}
                      <div className="space-y-2">
                        <label className="block text-xs font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                          Role
                        </label>
                        <select
                          name="role"
                          value={temp.role}
                          onChange={handleTempChange}
                          className="w-full px-3 py-2 border rounded-lg outline-none transition text-gray-700 text-sm"
                          style={{ 
                            borderColor: 'rgba(18, 76, 114, 0.3)',
                            backgroundColor: 'white'
                          }}
                        >
                          <option value="">Select Role</option>
                          {roles.map((r) => (
                            <option key={r.userRoles_id} value={r.role}>{r.role}</option>
                          ))}
                        </select>
                      </div>

                       <div className="flex items-center gap-2 mt-1 md:col-span-3">
    <input
      type="checkbox"
      id="is_default"
      checked={temp.is_default}
      onChange={(e) =>
        setTemp((prev) => ({ ...prev, is_default: e.target.checked }))
      }
      className="w-4 h-4 accent-primary-800 cursor-pointer"
    />
    <label htmlFor="is_default" className="text-sm cursor-pointer" style={{ color: 'rgb(18, 76, 114)' }}>
      Set as Default
    </label>
  </div>
                    </div>

                    <button
                      onClick={addUserCompany}
                      className="w-full bg-primary-800 text-white px-4 py-2.5 rounded-lg transition-all hover:bg-primary-700 text-sm font-medium"
                      style={{ 
                        backgroundColor: 'rgb(18, 76, 114)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.9)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgb(18, 76, 114)';
                      }}
                    >
                      + Add Company Access
                    </button>
                  </div>

                  {/* Assigned Companies List */}
              {formData.userCompanies.map((entry, idx) => (
  <div key={idx} className="flex justify-between items-center bg-gray-50 p-3 rounded-lg border" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>
    <div className="text-sm flex items-center gap-2 flex-wrap">
      {/* ✅ Default Badge */}
      {entry.is_default && (
        <span className="text-xs font-semibold px-2 py-0.5 rounded-full text-white" style={{ backgroundColor: 'rgb(18, 76, 114)' }}>
          Default
        </span>
      )}
      <span className="font-medium">{entry.companyCode}</span> —
      <span className="text-gray-600 mx-2">
        {departmentsMaster.find(d => Number(d.department_id) === Number(entry.department_id))?.department_name || "N/A"}
      </span> —
      <span className="text-primary-700">{entry.role}</span>
    </div>
    <div className="flex items-center gap-3">
      {/* ✅ Set as Default button (only show if not already default) */}
      {!entry.is_default && (
        <button
          onClick={() => {
            setFormData((prev) => ({
              ...prev,
              userCompanies: prev.userCompanies.map((uc, i) => ({
                ...uc,
                is_default: i === idx,
              })),
            }));
          }}
          className="text-xs font-medium transition-colors"
          style={{ color: 'rgb(18, 76, 114)' }}
        >
          Set Default
        </button>
      )}
      <button
        onClick={() => removeUserCompany(idx)}
        className="text-red-600 hover:text-red-800 text-sm font-medium transition-colors"
      >
        Remove
      </button>
    </div>
  </div>
))}
                </div>

                {/* Status Checkbox */}
                <div className="space-y-2 pt-2">
                  <label className="flex items-center space-x-3 cursor-pointer group">
                    <div className="relative">
                      <input
                        type="checkbox"
                        id="is_active"
                        name="is_active"
                        checked={formData.is_active}
                        onChange={handleChange}
                        className="sr-only"
                      />
                      <div 
                        className={`w-6 h-6 rounded border flex items-center justify-center transition-all duration-200 group-hover:border-primary-600 ${
                          formData.is_active 
                            ? 'bg-primary-600 border-primary-600 shadow-sm' 
                            : 'bg-white border-gray-400'
                        }`}
                      >
                        {formData.is_active && (
                          <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                          </svg>
                        )}
                      </div>
                    </div>
                    <span className="text-sm font-medium group-hover:text-primary-700 transition-colors" style={{ color: 'rgb(18, 76, 114)' }}>
                      Active User
                    </span>
                  </label>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="flex flex-col sm:flex-row justify-end gap-3 p-6 border-t rounded-b-2xl" style={{ 
              borderColor: 'rgba(18, 76, 114, 0.1)',
              background: 'linear-gradient(to right, transparent, rgba(18, 76, 114, 0.05))'
            }}>
              <button
                onClick={() => setShowModal(false)}
                className="px-5 py-2.5 bg-white border rounded-lg transition-all font-medium"
                style={{ 
                  color: 'rgb(18, 76, 114)',
                  borderColor: 'rgba(18, 76, 114, 0.3)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'white';
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-5 py-2.5 text-white font-medium rounded-lg transition-all"
                style={{ 
                  backgroundColor: 'rgb(18, 76, 114)',
                  cursor: 'pointer',
                  boxShadow: '0 10px 15px -3px rgba(18, 76, 114, 0.2)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.9)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgb(18, 76, 114)';
                }}
              >
                {editingUser ? 'Update User' : 'Add User'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}